import { Injectable, ɵComponentType } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { Observable } from 'rxjs'; 
import {DynamicDialog} from './dynamicdialog.component';
import { ResultDataSet, InputData } from './dynamicdialog.interface';


@Injectable()
export class DynamicDialogService{
    constructor(public dialog: MatDialog) {}
    private dirtyForms:{formName:String,dirty:boolean}[]=[];
    private containerCount:number = 0;
    currentDialog:any = null;

    public getcontainerId():string{
        let returnValue:string = "dialogContentContainer"+this.containerCount;
        this.containerCount++;
        return returnValue;
    }

    public setDirtyFlag(formName:any,isDirty:boolean){
        let formExists:boolean = false;
        this.dirtyForms.map((dirtyForm)=>{
            if(dirtyForm.formName.toLowerCase() === formName.toLowerCase() ){
                formExists = true;
                dirtyForm.dirty = isDirty;
            }
        })
        if(!formExists){
            this.dirtyForms.push({formName:formName,dirty:isDirty})
        }
    }

    public isDirty(formName:string):boolean{
        for (let index = 0; index < this.dirtyForms.length; index++) {
            if(this.dirtyForms[index].formName.toLowerCase() === formName.toLowerCase()){
                return this.dirtyForms[index].dirty;
            }
            
        }
        return false;
    }

    public discardFormStatus(formName:string){
        for (let index = 0; index < this.dirtyForms.length; index++) {
            if(this.dirtyForms[index].formName.toLowerCase() === formName.toLowerCase()){
                this.dirtyForms.splice(index,1);
            }
            
        }
    }

    public show(component:any, inputData:InputData = {configurationData:[],obj:null}, disableClose:boolean=true,fullScreen:boolean=false):Observable<ResultDataSet>{
        // let dialogConfig:{}
        const dialogRef = this.dialog.open(DynamicDialog,{
            data:{component:component,input:inputData,fullScreen:fullScreen},maxWidth:fullScreen ? "100vw" :"85vw",width:fullScreen ? "100vw" :"85vw",disableClose:disableClose, height:fullScreen ? "100vh" : undefined
        });
        this.currentDialog = dialogRef;
        
        return new Observable<ResultDataSet>(observer =>{
            dialogRef.afterClosed().subscribe(dialogResult => {
                observer.next(dialogResult);
            });
        })
    };
};